import { InputRow } from './InputRow';
import LocalDate from '../../../components/LocalDate';

export function SoilDate({ rx }) {
  return (
    <InputRow
      name="Soil Date Referenced"
      value={rx.soilDate && <LocalDate value={rx.soilDate} timeZone="UTC" />}
    />
  );
}
